/**
 * @todo https://blog.axway.com/amplify-products/api-management/introduction-to-rfc-7807
 */
export default class ApiError extends Error {
  constructor(status = 400, info, ...params) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(...params);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiError);
    }

    this.name = 'ApiError';
    this.status = status;
    this.info = { ...info, status }
  }
}
